import { API_URL } from "@/constant";
import axios from 'axios';

export function getAllLanguages() {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.get(API_URL.GET_LANGUAGE,);
        if (response.status === 401) {
          localStorage.clear();
          reject(response.data);
          window.location.href = '/';
        }
  
        resolve({ data: response.data });
      } catch (error: any) {
        if (error.response) {
          reject(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  }